const ROTATIONS = [0, 90, 180, 270];

function normalizeRotation(value) {
  return ROTATIONS.includes(Number(value)) ? Number(value) : 0;
}

/** SVG matrix: rotate clockwise around the node center, then mirror left-to-right. */
export function schemeNodeTransform(
  width,
  height,
  rotation = 0,
  mirrored = false
) {
  const angle = (normalizeRotation(rotation) * Math.PI) / 180;
  const cos = Math.round(Math.cos(angle));
  const sin = Math.round(Math.sin(angle));
  const mirrorX = mirrored ? -1 : 1;
  const a = mirrorX * cos;
  const b = sin;
  const c = mirrorX * -sin;
  const d = cos;
  const cx = width / 2;
  const cy = height / 2;
  const e = cx - a * cx - c * cy;
  const f = cy - b * cx - d * cy;
  const num = (value) => Number(value.toFixed(6)).toString();
  return `matrix(${[a, b, c, d, e, f].map(num).join(" ")})`;
}

/** Axis-aligned footprint after rotation; the original node center stays fixed. */
export function schemeNodeBounds(pos, width, height, rotation = 0) {
  const rotated = [90, 270].includes(normalizeRotation(rotation));
  const w = rotated ? height : width;
  const h = rotated ? width : height;
  return { x: pos.x + (width - w) / 2, y: pos.y + (height - h) / 2, w, h };
}
